import { __resetStyles } from '@griffel/react';
// this style must be applied to the html element to disable scrolling
export const useHTMLNoScrollStyles = /*#__PURE__*/__resetStyles("r6pzz3z", null, [".r6pzz3z{overflow-y:hidden;overflow-y:clip;scrollbar-gutter:stable;}"]);
export const useBodyNoScrollStyles = /*#__PURE__*/__resetStyles("r144vlu9", null, [".r144vlu9{overflow-y:hidden;}"]);
//# sourceMappingURL=useDisableBodyScroll.styles.js.map